import React, { useRef } from "react";
import { cn } from "../lib/utils";
import Container from "./ui/Container";
import Section from "./ui/Section";
import { GatsbyImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

type Props = {
  className?: string;
  data: any;
};

const Gallery = ({ className, data }: Props) => {
  const sliderRef = useRef(null);
  const [loading, setLoading] = React.useState(true);
  var slides = Array();

  var cnt = 0;
  for (let i = 0; i < data.length; i++) {
    if (i == 1) {
      slides.push([data[i - 1], data[i]]);
      cnt = 0;
    }
    if (i > 1 && cnt < 4) slides.push([data[i]]);

    if (cnt == 5) {
      cnt = 0;
      slides.push([data[i - 1], data[i]]);
    }
    cnt++;
  }

  return (
    <Section className={cn("my-0 bg-primary pt-0", className)}>
      <Container className="!max-w-full overflow-hidden !px-0">
        <Swiper
          ref={sliderRef}
          slidesPerView={1}
          modules={[Autoplay]}
          autoplay={{ delay: 0 }}
          speed={3000}
          loop={true}
          freeMode={true}
          breakpoints={{
            390: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={24}
          onSwiper={(swiper) => setLoading(false)}
        >
          {slides &&
            !loading &&
            slides.map((slide, idx: number) => (
              <SwiperSlide
                key={idx}
                className={`grid sm:h-[50vw] md:h-[30vw] ${
                  slide.length > 1 ? "grid-rows-2" : ""
                } gap-6 object-cover`}
              >
                {slide.map((item, idy: number) => (
                  <div
                    key={idy}
                    className="h-full overflow-hidden object-cover"
                  >
                    <GatsbyImage
                      image={item.image.asset.gatsbyImageData}
                      alt={item.title}
                      className={`${
                        slide.length > 1 ? "aspect-[16/9]" : "aspect-[6/7]"
                      } object-cover`}
                    />
                  </div>
                ))}
              </SwiperSlide>
            ))}
        </Swiper>
      </Container>
    </Section>
  );
};

export default Gallery;
